import { TimeUnit } from '../../types/time';

const MIN_ANNOTATION_DURATION = 10; // 10 seconds minimum

export interface TimeValidationResult {
  isValid: boolean;
  message?: string;
}

export function validateTimeUnit(value: number, unit: TimeUnit): TimeValidationResult {
  if (isNaN(value)) {
    return {
      isValid: false,
      message: `Please enter a valid ${unit}`
    };
  }

  if (value < 0) {
    return {
      isValid: false,
      message: `${unit} cannot be negative`
    };
  }

  if (unit === 'seconds' && (value < 0 || value > 59)) {
    return {
      isValid: false,
      message: 'Seconds must be between 0 and 59'
    };
  }

  return { isValid: true };
}

export function validateTimeRange(
  startTime: number,
  endTime: number,
  duration: number
): TimeValidationResult {
  if (startTime < 0) {
    return {
      isValid: false,
      message: 'Start time cannot be negative'
    };
  }

  if (startTime >= endTime) {
    return {
      isValid: false,
      message: 'End time must be after start time'
    };
  }

  if (endTime > duration) {
    return {
      isValid: false,
      message: 'End time cannot exceed video duration'
    };
  }

  if (endTime - startTime < MIN_ANNOTATION_DURATION) {
    return {
      isValid: false,
      message: `Annotation must be at least ${MIN_ANNOTATION_DURATION} seconds long`
    };
  }

  return { isValid: true };
}

export function calculateEndTime(startTime: number, duration: number): number {
  return Math.min(startTime + MIN_ANNOTATION_DURATION, duration);
}